module.exports = __webpack_public_path__ + "img/tl4.27643037.webp";